import type { IconDef } from '../types';

export const bubbleSpeech: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M18.9854 2C21.753 2 24 4.20016 24 6.91016V14.7402C23.9999 17.4501 21.7529 19.6504 18.9854 19.6504H10.8457L6.39355 22.7695C6.17918 22.9195 5.91342 22.9999 5.6582 23C5.46433 23 5.25988 22.9502 5.07617 22.8604C4.64724 22.6404 4.38086 22.22 4.38086 21.75V19.5996C1.91996 19.2994 0.000240202 17.2301 0 14.7305V6.91016C0 4.20016 2.24699 2 5.01465 2H18.9854ZM5.32129 3.70996C3.68725 3.63996 2.29805 4.89023 2.22656 6.49023L1.87891 14.2998C1.80742 15.8998 3.08471 17.2601 4.71875 17.3301L18.6787 17.9297C20.3126 17.9997 21.7017 16.7502 21.7734 15.1504L22.1211 7.33984C22.1925 5.73992 20.9152 4.37957 19.2812 4.30957L5.32129 3.70996Z',
    },
  ],
};
